import { useEffect } from "react";
import Contact from "@/components/site/Contact";

export default function ContactPage() {
    useEffect(() => {
        document.title = "Contact — MIDI Pictures";
    }, []);
    return (
        <main data-testid="contact-page" className="bg-black pt-32">
            <Contact />
        </main>
    );
}
